import React, {useCallback, useEffect, useRef, useState} from 'react';
import {WithDropdown, WithPopover} from "../../../HOCs";
import cx from "classnames";
import {LLBettingButton} from "../../index";
import {throttle} from "lodash";


export const LLWidgetsBetsWithDropdown = (
    {
        bets,
        dropdownWidth,
        dropdownRef,
        viewSize,
    }
) => {
    const [activeBet, setActiveBet] = useState(bets?.length ? bets[0] : null);

    const getDropdownSrc = () => bets.map(bet => ({
        label: bet.id,
        element: (
            <p className="ll-widget-item-dropdown-content__bet">
                <span className="ll-widget-item-dropdown-content__bet-name">
                    {bet.name}
                </span>
                <span className="ll-widget-item-dropdown-content__bet-value">
                    {bet.renderOdd}
                </span>
            </p>
        )
    }));

    return (
        <div className="ll-widget-item__bets-with-dropdown">
            <div ref={dropdownRef} className="ll-widget-item__dropdown-wrp">
                <WithDropdown
                    dataSource={{
                        submenu: getDropdownSrc(),
                    }}
                    menuItemIsActive={(item) => item?.label === activeBet?.id}
                    onMenuItemClick={(item) => setActiveBet(bets.find((bet) => bet.id === item.label))}
                    openBehavior="click"
                    customClasses="ll-widget-item__dropdown"
                    menuClasses={cx(
                        "ll-widget-item-dropdown-content",
                        `ll-widget-item-dropdown-content--${viewSize}`
                    )}
                    disablePortal={false}
                    popoverWidth={dropdownWidth}
                >
                    <WithPopover>
                        <span>{activeBet?.name}</span>
                    </WithPopover>
                </WithDropdown>
            </div>

            {!!activeBet &&
                <LLBettingButton
                    columnCount={0}
                    withPopoverOnMobile={true}
                    bet={activeBet}
                    nameAppearance={false}
                    customClasses="ll-widget-item__bet ll-widget-item__bet--with-dropdown"
                />
            }
        </div>
    );
};